import React from "react";
import { Link } from "react-router-dom";

const HeroBannner = ({
  breadcrumbs = [],
  title = "",
  subtitle = "",
  badge = null,
  icon = null,
  stat = null,
  accentColor = "#ff601e",
}) => {
  return (
    <div
      className="relative overflow-hidden w-full mt-36 lg:mt-0"
      style={{
        background:
          "linear-gradient(145deg,#0a1715 0%,#162c2a 38%,#1e4a46 68%,#284b49 100%)",
      }}
    >
      {/* Pharmacy cross watermark */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          opacity: 0.035,
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='20' y='8' width='8' height='32' rx='3' fill='white'/%3E%3Crect x='8' y='20' width='32' height='8' rx='3' fill='white'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
          backgroundSize: "48px 48px",
        }}
      />

      {/* Glow orbs */}
      <div
        className="absolute -top-20 -right-20 w-96 h-96 rounded-full pointer-events-none"
        style={{
          background: `radial-gradient(circle, ${accentColor}22 0%, transparent 65%)`,
        }}
      />
      <div
        className="absolute -bottom-10 left-1/4 w-80 h-80 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(95,189,179,.13) 0%, transparent 65%)",
        }}
      />
      <div
        className="absolute top-0 left-0 w-72 h-full pointer-events-none"
        style={{
          background:
            "linear-gradient(to right, rgba(95,189,179,.07), transparent)",
        }}
      />

      {/* Accent lines */}
      <div
        className="absolute top-0 right-[15%] w-px h-full pointer-events-none opacity-10"
        style={{
          background:
            "linear-gradient(to bottom, transparent, #5fbdb3, transparent)",
        }}
      />
      <div
        className="absolute top-0 right-[35%] w-px h-full pointer-events-none opacity-5"
        style={{
          background:
            "linear-gradient(to bottom, transparent, #ff601e, transparent)",
        }}
      />

      {/* Bottom shimmer */}
      <div
        className="absolute bottom-0 left-0 right-0 h-px pointer-events-none"
        style={{
          background:
            "linear-gradient(to right, transparent, #5fbdb3, #ff601e, transparent)",
        }}
      />

      {/* Content */}
      <div className="relative px-6 sm:px-10 lg:px-16 pt-10 pb-12 flex items-start justify-between gap-10">
        {/* Left */}
        <div className="flex-1 min-w-0">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2.5 mb-5 flex-wrap">
            {breadcrumbs.map((crumb, i) => {
              const isLast = i === breadcrumbs.length - 1;
              return (
                <React.Fragment key={i}>
                  {i > 0 && (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-white/20 flex-shrink-0"
                    >
                      <polyline points="9 18 15 12 9 6" />
                    </svg>
                  )}
                  {isLast ? (
                    <span
                      className="text-[13px] font-semibold tracking-wide"
                      style={{ color: accentColor }}
                    >
                      {crumb.label}
                    </span>
                  ) : crumb.to ? (
                    <Link
                      to={crumb.to}
                      className="text-[13px] font-medium text-white/45 hover:text-white/75 transition-colors duration-150"
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="text-[13px] font-medium text-white/45">
                      {crumb.label}
                    </span>
                  )}
                </React.Fragment>
              );
            })}
          </nav>

          {/* Badge */}
          {badge && (
            <div className="inline-flex items-center gap-2 mb-3">
              <span
                className="text-[10px] font-bold uppercase tracking-[.22em] px-3 py-1 rounded-full border"
                style={{
                  color: "#5fbdb3",
                  borderColor: "rgba(95,189,179,.25)",
                  background: "rgba(95,189,179,.08)",
                }}
              >
                ✦ {badge}
              </span>
            </div>
          )}

          {/* Title */}
          <h1
            className="font-black text-white tracking-tight leading-none mb-3 "
            style={{
              fontSize: "clamp(32px, 5vw, 56px)",
              fontFamily: "'Nunito', sans-serif",
              textShadow: "0 2px 32px rgba(0,0,0,.3)",
            }}
          >
            {title}
          </h1>

          {/* Subtitle */}
          {subtitle && (
            <p
              className="text-[14px] leading-relaxed max-w-[380px]"
              style={{
                color: "rgba(255,255,255,.5)",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        {/* Right: icon + stat */}
        {(icon || stat) && (
  <div className="hidden sm:flex flex-col items-end gap-4 flex-shrink-0">            {icon && (
              <div
                className="w-20 h-20 sm:w-24 sm:h-24 rounded-3xl flex items-center justify-center"
                style={{
                  background: "rgba(255,255,255,.04)",
                  border: "1px solid rgba(255,255,255,.08)",
                  boxShadow: `0 8px 40px ${accentColor}22`,
                }}
              >
                {icon}
              </div>
            )}
            {stat && (
              <div
                className="flex items-center gap-3 rounded-2xl px-5 py-3"
                style={{
                  background: "rgba(255,255,255,.05)",
                  border: "1px solid rgba(255,255,255,.09)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <div
                  className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{
                    background: `${accentColor}22`,
                    border: `1px solid ${accentColor}33`,
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 22"
                    fill={accentColor}
                  >
                    <path d="M6.386 0C4.743 0 3.1.644 1.859 1.942-.621 4.537-.618 8.697 1.859 11.294l9.468 9.929c.19.162.42.286.668.286s.473-.124.663-.286c3.158-3.305 6.318-6.614 9.477-9.919 2.48-2.596 2.48-6.757 0-9.353C19.655-.644 15.56-.644 13.08 1.95L12 3.076 10.913 1.942C9.673.644 8.03 0 6.386 0z" />
                  </svg>
                </div>
                <div>
                  <p
                    className="font-black text-white leading-none"
                    style={{ fontSize: 26, fontFamily: "'Nunito', sans-serif" }}
                  >
                    {stat.value}
                  </p>
                  <p
                    className="text-[11px] text-white/35 mt-0.5"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {stat.label}
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Bottom page fade */}
      <div
        className="h-10 w-full pointer-events-none"
        style={{ background: "linear-gradient(to top, #f8fafa, transparent)" }}
      />
    </div>
  );
};

export default HeroBannner;
